// @ts-ignore

import { css } from "@compiled/react";
import { FormattedMessage, useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { ContentBlock } from "@/components/wpl/content-block/src/content-block";
import { Picture } from "@/components/wpl/image/src/image";
import { DEFAULT_VALUES } from "@/libraries/web-framework/src/localization/values";
import { getDevOpsSectionImage } from "@/templates/software/jira/features/jira-software-features-page/src/localized-images";

const devOpsSectionStyle = css({
    "backgroundColor": "#091e42",
    "backgroundPosition": "center",
    "backgroundRepeat": "no-repeat",
    "backgroundSize": "cover",
    "color": "#ffffff",
    "padding": "96px 96px 96px 0px",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".content-container": {
        padding: "16px 0",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h2: {
            fontWeight: "normal",
            [media.above.sm]: {
                fontSize: "2.25rem"
            },
            [media.below.sm]: {
                fontSize: "1.5rem"
            }
        }
    },

    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".desktop-img": {
        display: "block",
        flexDirection: "column",
        justifyContent: "center",
        padding: "16px 0"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".mobile-img": {
        display: "none",
        flexDirection: "column",
        justifyContent: "center",
        padding: "16px 0"
    },

    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".dev-ops-content": {
        padding: "32px 0"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".text-section": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& > *": {
            margin: "0 100px 24px 50px"
        },
        [media.only.sm]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "& > *": {
                margin: "0 !important"
            }
        }
    },

    [media.above.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".section-container": {
            maxWidth: "1200px",
            margin: "auto",
            display: "grid",
            gridTemplateColumns: "5fr 5fr",
            gridColumnGap: "0%",
            alignItems: "center"
        }
    },

    [media.below.sm]: {
        "padding": `${token("space.200")}`,

        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".desktop-img": {
            display: "none"
        },

        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mobile-img": {
            display: "block"
        }
    }
});

const DevOpsSection = () => {
    const intl = useIntl();

    return (
        <section css={devOpsSectionStyle}>
            <div className="section-container">
                {/* only renders on larger screens */}
                <div className="desktop-img">
                    <DevOpsImage />
                </div>
                <div className="content-container">
                    <div className="dev-ops-content">
                        <ContentBlock
                            headerType="h2"
                            headerText={
                                <FormattedMessage
                                    id="JiraSoftwareFeaturesPageTemplate.devOpsSection.header"
                                    defaultMessage="Open DevOps"
                                    values={DEFAULT_VALUES}
                                />
                            }
                            bodyText={
                                <FormattedMessage
                                    id="JiraSoftwareFeaturesPageTemplate.devOpsSection.body"
                                    defaultMessage="No single vendor can deliver everything your team needs to do DevOps. But using multiple tools can be messy. With Atlassian Open DevOps - you don’t need to choose.<br></br><br></br>Using Jira as the central source of truth for your DevOps practices, unlock the extensibility of an open, diverse toolchain while keeping the ease and coordination of an all-in-one."
                                    values={DEFAULT_VALUES}
                                />
                            }
                            ctaProps={{
                                buttonProps: {
                                    text: intl.formatMessage({
                                        id: "JiraSoftwareFeaturesPageTemplate.devOpsSection.cta",
                                        defaultMessage: "Learn more"
                                    }),
                                    url: "https://www.atlassian.com/solutions/devops",
                                    type: "secondary",
                                    color: "white",
                                    size: "small",
                                    dataEventProps: {
                                        "data-event-component": "linkButton",
                                        "data-event-container": "devOpsSection",
                                        "data-event": "clicked",
                                        "data-product-key": "jiraSoftware"
                                    }
                                }
                            }}
                        />
                    </div>

                    {/* only renders on smaller screens */}
                    <div className="mobile-img">
                        <DevOpsImage />
                    </div>
                </div>
            </div>
        </section>
    );
};

const DevOpsImage = () => {
    const intl = useIntl();
    const localizedImageSrc = getDevOpsSectionImage(intl.locale);
    return (
        <Picture
            image={{
                src: localizedImageSrc,
                alt: ""
            }}
        />
    );
};

export default DevOpsSection;
